import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 

import * as apiUrl from "../../apiUrl";

function CareerBanner() {

  const [CareerBanner, setCareerBanner] = useState([]);

  useEffect(() => {
    const fetchCareerBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/careers/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCareerBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCareerBanner();
  }, []);

  return ( 
      <div className='common-banner-sec common-flex-center career-banner'
      style={{
        backgroundImage: `url(${
          apiUrl.apiUrl + `/` + CareerBanner.banner_image
        })`,
      }}
      >
        <div className='overlay'></div>
        <Container fluid>
          <Row className='common-flex-center'>
            <Col md={8}>
                <div className=' '>
                    <h1 className='common-head whiteColor'>{CareerBanner.banner_title}</h1>
                    <p className='common-para whiteColor'>{CareerBanner.banner_description}</p>
                </div>
            </Col>
          </Row>
        </Container>
      </div> 
  );
}

export default CareerBanner;